__turbopack_context__.v({
  "card": "investor-card-module-scss-module__S-KEYa__card",
  "container": "investor-card-module-scss-module__S-KEYa__container",
  "header": "investor-card-module-scss-module__S-KEYa__header",
  "image": "investor-card-module-scss-module__S-KEYa__image",
  "investorHeading": "investor-card-module-scss-module__S-KEYa__investorHeading",
});
